export enum ModuleTokens {
  Name = 'recaptcha'
}
